import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { useContext } from 'react';
import type { HTMLTagProps } from '../../../../types';
import { BottomDrawerContext } from '..';
type BottomDrawerHandleProps = HTMLTagProps<'button'>;
export const Handle = t0 => {
  const $ = _c(14);
  let className;
  let onClick;
  let restProps;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      onClick,
      type: t1,
      ...restProps
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = onClick;
    $[3] = restProps;
    $[4] = t1;
  } else {
    className = $[1];
    onClick = $[2];
    restProps = $[3];
    t1 = $[4];
  }
  const type = t1 === undefined ? "button" : t1;
  const context = useContext(BottomDrawerContext);
  if (!context) {
    throw new Error("BottomDrawer.Handle\uC740 BottomDrawer \uB0B4\uBD80\uC5D0\uC11C\uB9CC \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.");
  }
  let t2;
  if ($[5] !== className) {
    t2 = cn("h-4 w-44 cursor-pointer bg-Gray-300 transition-colors hover:bg-Gray-400 active:bg-Gray-500", className);
    $[5] = className;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== onClick) {
    t3 = e => {
      onClick?.(e);
    };
    $[7] = onClick;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== restProps || $[10] !== t2 || $[11] !== t3 || $[12] !== type) {
    t4 = <button {...restProps} className={t2} type={type} onClick={t3} />;
    $[9] = restProps;
    $[10] = t2;
    $[11] = t3;
    $[12] = type;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};